import { ConnectHost, ConnectModule } from '@atlassian/bitbucket-connect-js';

import LinkerHOC, { LinkerProps } from '../shared/linkerHOC';

import IframeWrapper from './inlineDialogIframeWrapper';

export interface InlineDialogLinkerProps extends LinkerProps {
  connectHost: typeof ConnectHost;
  module: ConnectModule;
  handleHideInlineDialog: Function;
}

// eslint-disable-next-line import/no-default-export
export default LinkerHOC<InlineDialogLinkerProps>(
  ({ connectHost, options, module: mod, handleHideInlineDialog }) => {
    return (
      <IframeWrapper
        connectHost={connectHost}
        module={mod}
        inlineDialogOptions={options}
        handleHideInlineDialog={handleHideInlineDialog}
      />
    );
  }
);
